module.exports = __webpack_public_path__ + "static/img/packaging_box.c4a70c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/packaging_box.jpg
// module id = w93T
// module chunks = 1